import { useCallback } from 'react'
import { useUpsertTripChatRecentSearchMutation } from 'tripPlanner/hooks/api/tripChatRecentSearch'
import type { UpsertTripChatRecentSearchBody } from 'tripPlanner/utils/tripChatRecentSearchPayload'

export default function usePersistTripChatRecentSearch(chatId: number | undefined) {
  const { mutate } = useUpsertTripChatRecentSearchMutation()

  return useCallback((body: UpsertTripChatRecentSearchBody) => {
    if (!chatId) return
    mutate({ chatId, body })
  }, [chatId, mutate])
}
